module.exports = __webpack_public_path__ + "img/logo-mark.5d5e5325.png";